import { hsl, parseToHsl } from "polished";
import type { HslColor } from "polished/lib/types/color";

export function getCorrectedColor(color: string | null, maxLightness: number): string {
  // the correction ensures that very light colors (close or equal to white) are still visible on white background, e.g. in the chart
  if (!color) {
    return "";
  }
  const hslColor: HslColor = parseToHsl(color);
  if (hslColor.lightness > maxLightness) {
    hslColor.lightness = maxLightness;
    // when adapting lightness, also reduce saturation, otherwise colors appear too strong
    hslColor.saturation = hslColor.saturation * 0.3;
  }
  return hsl(hslColor);
}
